import React, { useState, useEffect, useCallback } from 'react';
import MetaService from '../../../services/meta.service';

const INTEGRATION_META = {
  shopify:       { name: 'Shopify',            description: 'Sincroniza productos, pedidos y clientes', color: 'rgba(149,191,71,0.15)', stroke: '#95bf47', icon: ShopifyIcon },
  whatsapp:      { name: 'WhatsApp Business',  description: 'Canal de atención al cliente vía WhatsApp', color: 'rgba(37,211,102,0.15)', stroke: '#25d366', icon: WhatsAppIcon },
  instagram:     { name: 'Instagram Business', description: 'Canal de mensajería directa vía Instagram', color: 'rgba(225,48,108,0.15)', stroke: '#e1306c', icon: InstagramIcon },
  google_sheets: { name: 'Google Sheets',      description: 'Registro de pedidos y datos en hojas', color: 'rgba(66,133,244,0.15)', stroke: '#4285f4', icon: GoogleIcon },
  google:        { name: 'Google',             description: 'Gmail, Calendar, Drive y más', color: 'rgba(66,133,244,0.15)', stroke: '#4285f4', icon: GoogleIcon },
};

function ShopifyIcon({ stroke }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2">
      <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
      <line x1="3" y1="6" x2="21" y2="6"/>
      <path d="M16 10a4 4 0 0 1-8 0"/>
    </svg>
  );
}
function WhatsAppIcon({ stroke }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
  );
}
function InstagramIcon({ stroke }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
      <circle cx="12" cy="12" r="4"/>
      <circle cx="17.5" cy="6.5" r="0.5" fill={stroke}/>
    </svg>
  );
}
function GoogleIcon({ stroke }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2">
      <rect x="2" y="3" width="20" height="14" rx="2"/>
      <polyline points="8 21 12 17 16 21"/>
      <line x1="12" y1="17" x2="12" y2="3"/>
    </svg>
  );
}

function isMetaSlug(slug) {
  return slug === 'whatsapp' || slug === 'instagram';
}

function IntegrationCard({ slug, required, connected, connecting, onConnect, onDisconnect }) {
  const meta = INTEGRATION_META[slug] || { name: slug, description: '', color: 'rgba(124,58,237,0.15)', stroke: '#7c3aed', icon: null };
  const Icon = meta.icon;

  return (
    <div style={{
      border: connected ? '1px solid rgba(34,197,94,0.25)' : '1px solid rgba(255,255,255,0.08)',
      borderRadius: 12,
      padding: '16px 20px',
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      background: connected ? 'rgba(34,197,94,0.04)' : 'rgba(255,255,255,0.02)',
      transition: 'all 0.2s',
    }}>
      <div style={{
        width: 44, height: 44, borderRadius: 10, flexShrink: 0,
        background: meta.color,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        {Icon && <Icon stroke={meta.stroke} />}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
          <span style={{ color: 'white', fontSize: 14, fontWeight: 600 }}>{meta.name}</span>
          {!connected && required && (
            <span style={{
              background: 'rgba(248,113,113,0.1)', color: '#f87171',
              fontSize: 10, fontWeight: 600, padding: '2px 8px',
              borderRadius: 999, border: '1px solid rgba(248,113,113,0.2)',
            }}>Requerido</span>
          )}
          {!connected && !required && (
            <span style={{
              background: 'rgba(255,255,255,0.05)', color: '#888',
              fontSize: 10, fontWeight: 600, padding: '2px 8px',
              borderRadius: 999, border: '1px solid rgba(255,255,255,0.1)',
            }}>Opcional</span>
          )}
        </div>
        <div style={{ color: '#6b6b8a', fontSize: 12 }}>{meta.description}</div>
      </div>

      {connected ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
          <div style={{
            width: 32, height: 32, borderRadius: '50%',
            background: 'rgba(34,197,94,0.15)', border: '1px solid rgba(34,197,94,0.3)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M2.5 7l3 3 6-6" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <button onClick={onDisconnect} style={{ padding: '6px 12px', borderRadius: 8, background: 'transparent', border: '1px solid rgba(255,255,255,0.08)', color: '#666', fontSize: 11, fontWeight: 500, cursor: 'pointer' }}>
            Desconectar
          </button>
        </div>
      ) : (
        <button onClick={onConnect} disabled={connecting} style={{ padding: '7px 14px', borderRadius: 8, flexShrink: 0, background: connecting ? '#4a2a8a' : '#7c3aed', border: 'none', color: 'white', fontSize: 12, fontWeight: 600, cursor: connecting ? 'wait' : 'pointer', opacity: connecting ? 0.7 : 1 }}>
          {connecting ? 'Abriendo...' : 'Conectar'}
        </button>
      )}
    </div>
  );
}

const btnPrimary = (disabled) => ({
  flex: 2, background: disabled ? '#4a2a8a' : 'linear-gradient(135deg,#7c3aed,#5b21b6)',
  color: 'white', border: 'none', borderRadius: 10, padding: '13px 0',
  fontSize: 14, fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.5 : 1, textAlign: 'center',
});

const btnSecondary = {
  flex: 1, background: 'transparent', border: '1px solid rgba(255,255,255,0.12)',
  color: '#888', borderRadius: 10, padding: '13px 0', fontSize: 14,
  cursor: 'pointer', textAlign: 'center',
};

function readStoredAccountId() {
  // account_id se guarda en localStorage al activar (Step2Email) y sobrevive
  // entre pestañas, a diferencia del redemptionData del wizard (sessionStorage).
  // Necesario cuando se llega a este paso vía el enlace de verificación del correo.
  // Prioridad: la key PROPIA del redeem (OrganizationContext borra currentAccountId
  // para un usuario recién activado sin sesión), luego los fallbacks legacy.
  const own = localStorage.getItem('redeem_account_id');
  if (own) return own;
  try {
    const meta = JSON.parse(localStorage.getItem('currentAccountMeta') || '{}');
    if (meta?.id) return meta.id;
  } catch (_) { /* meta corrupto: ignorar */ }
  return localStorage.getItem('currentAccountId') || null;
}

export default function Step3Integrations({ wizard }) {
  const { templateData, connectedIntegrations, markIntegrationConnected, allRequiredConnected } = wizard;
  const [connecting, setConnecting] = useState(null);
  const [popupBlocked, setPopupBlocked] = useState(false);
  const [connectError, setConnectError] = useState('');

  const accountId = wizard.redemptionData?.account_id || readStoredAccountId();
  const jwtToken = wizard.jwtToken || localStorage.getItem('access_token');

  const selectedChannel = wizard.selectedChannel; // 'whatsapp' | 'instagram' | null
  const required = (templateData?.required_integrations || []).filter((slug) => {
    if (slug === 'whatsapp' || slug === 'instagram') return slug === selectedChannel;
    return true;
  });
  const optional = templateData?.optional_integrations || [];
  const allIntegrations = [
    ...required.map((s) => ({ slug: s, required: true })),
    ...optional.map((s) => ({ slug: s, required: false })),
  ];

  // Listen for OAuth success from popup
  const handleMessage = useCallback((event) => {
    if (event.origin !== window.location.origin) return;
    const type = event.data?.type;
    if (type === 'OAUTH_SUCCESS' || type === 'META_OAUTH_CALLBACK') {
      if (selectedChannel) {
        markIntegrationConnected(selectedChannel);
      }
      // InstagramOAuthCallback sends { type, platform, data: response.data }
      // where response.data = { message, data: { integration_id } }
      const integrationId =
        event.data.integration_id ||
        event.data.data?.integration_id ||
        event.data.data?.data?.integration_id;
      if (integrationId) {
        wizard.setIntegrationId(integrationId);
      }
      setConnecting(null);
    }
  }, [markIntegrationConnected, selectedChannel, wizard]);

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [handleMessage]);

  async function handleConnect(slug) {
    if (isMetaSlug(slug)) {
      setPopupBlocked(false);
      setConnectError('');
      if (!accountId) {
        // Sin account_id no se puede iniciar el OAuth. Pasa si se llegó aquí sin
        // los datos de la activación (p.ej. otra pestaña). Avisar en vez de fallar
        // en silencio (antes: "no pasaba nada" al tocar Conectar).
        setConnectError('No pudimos recuperar tu cuenta. Volvé a ingresar tu correo en el paso anterior.');
        return;
      }
      setConnecting(slug);
      const platform = slug === 'instagram' ? 'instagram' : 'whatsapp';
      try {
        const result = await MetaService.generateSignupUrl({ id: accountId, platform, token: jwtToken });
        if (result.success && result.data?.signupUrl) {
          const w = 600, h = 700;
          const left = window.screenX + (window.outerWidth - w) / 2;
          const top = window.screenY + (window.outerHeight - h) / 2;
          const popup = window.open(result.data.signupUrl, 'meta-signup', `width=${w},height=${h},left=${left},top=${top},scrollbars=yes,resizable=yes`);
          if (!popup) {
            // El navegador bloqueó el popup. NO navegamos la pestaña (perdería el
            // redeem): avisamos para que el usuario permita popups y reintente.
            setPopupBlocked(true);
            setConnecting(null);
            return;
          }
          setPopupBlocked(false);
          // Poll until popup closes, fetch integration_id, THEN mark connected
          // (marking connected enables the Continue button — must happen after setIntegrationId)
          const timer = setInterval(async () => {
            if (popup.closed) {
              clearInterval(timer);
              if (accountId) {
                const result = await MetaService.getLatestIntegration({ accountId, platform, token: jwtToken });
                if (result.integration_id) {
                  wizard.setIntegrationId(result.integration_id);
                }
              }
              // Suscribir el webhook de WhatsApp a Meta para que lleguen los
              // mensajes (el trigger lo crea el backend al activar; la suscripción
              // se hace desde acá, como en ConnectionsTable). Best-effort: si falla
              // no bloquea el flujo (el usuario puede reintentar desde el panel).
              if (slug === 'whatsapp') {
                try {
                  const apiBaseUrl = process.env.REACT_APP_CONNECTIONS_API_URL;
                  await MetaService.subscribeWebhook({
                    webhookUrl: `${apiBaseUrl}/webhooks/whatsapp`,
                    verifyToken: process.env.REACT_APP_META_VERIFY_TOKEN || 'zenit-dev-petstore',
                    subscribe: true,
                  });
                } catch (subErr) {
                  console.warn('[Step3] subscribeWebhook falló (non-fatal)', subErr);
                }
              }
              if (selectedChannel) {
                markIntegrationConnected(selectedChannel);
              }
              setConnecting(null);
            }
          }, 500);
        } else {
          setConnecting(null);
        }
      } catch (err) {
        console.error('[Step3] generateSignupUrl error', err);
        setConnecting(null);
      }
    }
  }

  function handleDisconnect(slug) {
    const next = new Set(connectedIntegrations);
    next.delete(slug);
    wizard.setConnectedIntegrations(next);
  }

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 17, fontWeight: 700, color: '#e2e2f0', marginBottom: 6 }}>
          Conecta tus integraciones
        </div>
        {allIntegrations.length > 0 && (
          <div style={{ fontSize: 13, color: '#6b6b8a' }}>
            Tu template <strong style={{ color: '#a78bfa' }}>{templateData?.template_name}</strong> requiere las siguientes conexiones para funcionar.
          </div>
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
        {allIntegrations.map(({ slug, required: req }) => (
          <IntegrationCard
            key={slug}
            slug={slug}
            required={req}
            connected={connectedIntegrations.has(slug)}
            connecting={connecting === slug}
            onConnect={() => handleConnect(slug)}
            onDisconnect={() => handleDisconnect(slug)}
          />
        ))}
      </div>

      {allIntegrations.length === 0 && (
        <div style={{ textAlign: 'center', padding: '32px 0', color: '#555', fontSize: 13 }}>
          Este template no requiere integraciones.
        </div>
      )}

      {popupBlocked && (
        <div style={{
          background: 'rgba(225,48,108,0.08)', border: '1px solid rgba(225,48,108,0.3)',
          borderRadius: 10, padding: '12px 16px', marginBottom: 20,
          color: '#f0a5c0', fontSize: 13, lineHeight: 1.5,
        }}>
          Tu navegador bloqueó la ventana de conexión. Permití las ventanas
          emergentes para este sitio y volvé a tocar “Conectar”.
        </div>
      )}

      {connectError && (
        <div style={{
          background: 'rgba(225,48,108,0.08)', border: '1px solid rgba(225,48,108,0.3)',
          borderRadius: 10, padding: '12px 16px', marginBottom: 20,
          color: '#f0a5c0', fontSize: 13, lineHeight: 1.5,
        }}>
          {connectError}
        </div>
      )}

      <div style={{
        background: 'rgba(124,58,237,0.08)', border: '1px solid rgba(124,58,237,0.2)',
        borderRadius: 10, padding: '12px 16px', marginBottom: 24,
        display: 'flex', gap: 10, alignItems: 'flex-start',
      }}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#a78bfa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 1 }}>
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        <p style={{ color: '#a78bfa', fontSize: 12, margin: 0, lineHeight: 1.5 }}>
          Puedes conectar o cambiar estas integraciones en cualquier momento desde el panel de configuración.
        </p>
      </div>

      <div style={{ display: 'flex', gap: 12 }}>
        <button onClick={() => wizard.goToStep(3)} style={btnSecondary}>← Atrás</button>
        <button
          onClick={() => wizard.goToStep(5)}
          disabled={!allRequiredConnected()}
          style={btnPrimary(!allRequiredConnected())}
        >
          Continuar →
        </button>
      </div>
    </div>
  );
}
